import React from "react";

import "./style.css";

const Modal = ({ handleClose, show, children, contentClassName = "" }) => {
  const showHideClassName = show ? "modal display-block" : "modal display-none";
  const modalContentClassName = `modal-main ${contentClassName}`.trim();

  return (
    <div className={showHideClassName}>
      <section className={modalContentClassName}>
        {children}
        <button className="closeButton" onClick={handleClose}>
          X
        </button>
      </section>
    </div>
  );
};

export default Modal;
